import { render, staticRenderFns } from "./qingjia.vue?vue&type=template&id=2a573728&scoped=true&"
import script from "./qingjia.vue?vue&type=script&lang=js&"
export * from "./qingjia.vue?vue&type=script&lang=js&"
import style0 from "./qingjia.vue?vue&type=style&index=0&id=2a573728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a573728",
  null
  
)

export default component.exports